export const isEmptyObject = (object: Record<string | number, unknown>) => {
	return Object.keys(object).length === 0 && object.constructor === Object;
};
